var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAngular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 39,
    viewBox: "0 0 37 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_946_14591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.484863 6.69631L18.4297 0.417114L36.8577 6.58468L33.874 29.9014L18.4297 38.3016L3.22703 30.0131L0.484863 6.69631Z",
    fill: "#E23237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8578 6.58468L18.4298 0.417114V38.3016L33.8741 29.9154L36.8578 6.58468Z",
    fill: "#B52E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4582 4.84045L7.27637 29.2735L11.4536 29.2037L13.6984 23.692H18.4724H18.4866H23.7294L26.1874 29.2735L30.1799 29.3433L18.4582 4.84045ZM18.4866 12.6685L22.266 20.4268H18.6429H18.4582H15.1619L18.4866 12.6685Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_946_14591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.5149,
    height: 38.1025,
    fill: "white",
    transform: "translate(0.470703 0.319458)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAngular);
export default __webpack_public_path__ + "static/media/icon_angular.4831dd419b8c39f6f91cfd68f1a1ae8a.svg";
export { ForwardRef as ReactComponent };